import React from "react";
import LegalPage from "./LegalPage";
import { BRAND } from "../lib/site";

export default function PrivacyPage() {
  return (
    <LegalPage title="Privacy Policy" kicker="Legal" testid="page-privacy">
      <h2 className="font-heading text-3xl text-white">1. Our Commitment</h2>
      <p>
        {BRAND.name} ("we," "our," "us") is deeply committed to protecting
        the privacy of every patient, prospective patient and visitor.
        This Privacy Policy explains how we collect, use, disclose and
        safeguard your information when you visit our website
        ({BRAND.domain}), engage with our consultation forms, or visit our
        surgical and recovery facilities in Raleigh, NC and Casper, WY.
      </p>

      <h2 className="font-heading text-3xl text-white">2. Information We Collect</h2>
      <p>
        We collect personal information you voluntarily provide, including
        your name, email, phone number, preferred consultation date, the
        service you are interested in, and any details you share in
        message fields. We may also collect non-identifying technical
        information such as browser type, device type and pages visited.
      </p>

      <h2 className="font-heading text-3xl text-white">3. How We Use Information</h2>
      <p>
        Your information is used to respond to consultation requests,
        schedule appointments, send confirmations, deliver post-operative
        care instructions, and improve the experience of our website.
        Protected Health Information (PHI) is handled under HIPAA
        requirements (see our HIPAA Compliance notice).
      </p>

      <h2 className="font-heading text-3xl text-white">4. Sharing &amp; Disclosure</h2>
      <p>
        We do not sell, rent or trade your personal information. We may
        share information with: (a) trusted vendors who process data on
        our behalf (e.g., secure form processing); (b) licensed
        professionals participating in your care; and (c) authorities
        when required by law.
      </p>

      <h2 className="font-heading text-3xl text-white">5. Data Security</h2>
      <p>
        We employ administrative, physical and technical safeguards —
        including encryption in transit, restricted access controls, and
        secure storage — to protect your information. No method of
        transmission over the Internet is 100% secure, but we work
        continuously to apply industry best practices.
      </p>

      <h2 className="font-heading text-3xl text-white">6. Cookies</h2>
      <p>
        Our site may use cookies to enhance browsing experience and
        analyse traffic. You may set your browser to refuse cookies; this
        may limit certain features.
      </p>

      <h2 className="font-heading text-3xl text-white">7. Your Rights</h2>
      <p>
        You may request access to, correction of, or deletion of personal
        information we hold about you, subject to legal and regulatory
        recordkeeping requirements applicable to medical practices.
      </p>

      <h2 className="font-heading text-3xl text-white">8. Children's Privacy</h2>
      <p>
        Our services are not directed to individuals under the age of 18.
        We do not knowingly collect personal information from minors
        without parental or guardian consent.
      </p>

      <h2 className="font-heading text-3xl text-white">9. Changes to this Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Material
        changes will be reflected by updating the "Last updated" date
        above. Continued use of our website indicates acceptance of any
        updates.
      </p>
    </LegalPage>
  );
}
